// Store Imports
import { inject } from '@angular/core'
import { patchState, signalStore, withMethods, withState } from '@ngrx/signals'

interface UiState {
	showSidenav: boolean
}

export const initialState: UiState = {
	showSidenav: false,
}

export const UiStore = signalStore(
	{ providedIn: 'root' },
	withState(initialState),
	withMethods((store) => ({
		openSidenav: (): void => {
			patchState(store, (state: UiState) => ({ showSidenav: true }))
		},
		closeSidenav: (): void => {
			patchState(store, (state: UiState) => ({ showSidenav: false }))
		},
	}))
)
